import { render, staticRenderFns } from "./informexvencerxls.vue?vue&type=template&id=0736bbd9&scoped=true"
import script from "./informexvencerxls.vue?vue&type=script&lang=js"
export * from "./informexvencerxls.vue?vue&type=script&lang=js"
import style0 from "./informexvencerxls.vue?vue&type=style&index=0&id=0736bbd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0736bbd9",
  null
  
)

export default component.exports